const localeEs = {
  es: {
    PAGE_TITLE: 'Vive la experiencia durante 7 días',
    PAGE_DESCRIPTION:
      'Completa tu formulario para activar tu prueba gratuita 🎉',

    TRIAL_FORM_TITLE: 'Vive la experiencia durante 7 días',
    TRIAL_FORM_DESCRIPTION:
      'Completa tu formulario para activar tu prueba gratuita',
    TRIAL_FORM_NAME: 'Nombre',
    TRIAL_FORM_LAST_NAME: 'Apellido',
    TRIAL_FORM_PHONE: 'Número de telefono',
    TRIAL_FORM_EMAIL: 'Correo corporativo',
    TRIAL_FORM_ROLE: 'Puesto o cargo',
    TRIAL_FORM_COMPANY: 'Empresa',
    TRIAL_FORM_ORGANIZATION_SIZE: 'Tamaño de la empresa',
    TRIAL_FORM_COUNTRY: 'País',
    TRIAL_FORM_TERMS_1: 'Al solicitar la demo acepto los',
    TRIAL_FORM_TERMS_2: 'términos y condiciones',
    TRIAL_FORM_TERMS_3: 'de Crehana',
    TRIAL_FORM_SUBMIT_1: 'Enviando...',
    TRIAL_FORM_SUBMIT_2: 'Enviar ahora',
    TRIAL_FORM_MAX_LENGTH_15: 'Máximo 15 caracteres',
    TRIAL_FORM_PHONE_PATTERN: 'Ingresa un número telefonico válido',
    TRIAL_FORM_EMAIL_PATTERN: 'Ingresa una dirección de correo válida',

    TRIAL_FORM_COUNTRY_1: 'Argentina',
    TRIAL_FORM_COUNTRY_2: 'Belice',
    TRIAL_FORM_COUNTRY_3: 'Bolivia',
    TRIAL_FORM_COUNTRY_4: 'Brasil',
    TRIAL_FORM_COUNTRY_5: 'Chile',
    TRIAL_FORM_COUNTRY_6: 'Colombia',
    TRIAL_FORM_COUNTRY_7: 'Costa Rica',
    TRIAL_FORM_COUNTRY_8: 'Cuba',
    TRIAL_FORM_COUNTRY_9: 'Ecuador',
    TRIAL_FORM_COUNTRY_10: 'El Salvador',
    TRIAL_FORM_COUNTRY_12: 'España',
    TRIAL_FORM_COUNTRY_13: 'Estados Unidos de América',
    TRIAL_FORM_COUNTRY_14: 'Guatemala',
    TRIAL_FORM_COUNTRY_15: 'Honduras',
    TRIAL_FORM_COUNTRY_16: 'México',
    TRIAL_FORM_COUNTRY_17: 'Nicaragua',
    TRIAL_FORM_COUNTRY_18: 'Panamá',
    TRIAL_FORM_COUNTRY_19: 'Paraguay',
    TRIAL_FORM_COUNTRY_20: 'Perú',
    TRIAL_FORM_COUNTRY_21: 'Puerto Rico',
    TRIAL_FORM_COUNTRY_22: 'República Dominicana',
    TRIAL_FORM_COUNTRY_23: 'Uruguay',
    TRIAL_FORM_COUNTRY_24: 'Venezuela',
    TRIAL_FORM_COUNTRY_25: 'Otros',

    TRIAL_FORM_COMPANY_SIZE_1: 'Hasta 150 personas',
    TRIAL_FORM_COMPANY_SIZE_2: 'De 151 a 1000 personas',
    TRIAL_FORM_COMPANY_SIZE_3: 'De 1001 a 5000 personas',
    TRIAL_FORM_COMPANY_SIZE_4: 'De 5001 a más personas',

    CONFIRMATION_DIALOG_TITLE: 'Muchas gracias por \n registrar tus datos',
    CONFIRMATION_DIALOG_DESCRIPTION:
      'En breve nos estaremos comunicando contigo \n para que vivas esta experiencia.',
    CONFIRMATION_DIALOG_BUTTON: 'Finalizar',

    SUCESS_DIALOG_TITLE: '¡Gracias por registrar tus datos!',
    SUCCESS_DIALOG_TITLE_DOWNLOADABLE: '¡Ya puedes descargar tu contenido!',
    SUCCESS_DIALOG_CTA_DOWNLOADABLE: 'Descargar',
    SUCESS_DIALOG_BODY:
      'En breve un asesor se contactará contigo para brindarte más información.',
    SUCESS_DIALOG_BUTTON: 'Entendido',

    LOADER_FINAL_STEP_TITLE:
      '¡Muchas gracias {{name}} por registrar tus datos!',
    LOADER_FINAL_STEP_1: 'Analizando las caracteristicas de tu empresa',
    LOADER_FINAL_STEP_2:
      'Contactándote con el mejor asesor según tus necesidades',
    LOADER_FINAL_STEP_3: 'Armándote una propuesta de Planes para Equipos',
    LOADER_FINAL_STEP_4: 'Contruyendo rutas de aprendizaje según tu industria',

    FORM_BY_STEPS_NAME_LABEL: 'Nombre',
    FORM_BY_STEPS_NAME_HINT: 'Escribe tu nombre',
    FORM_BY_STEPS_LASTNAME_LABEL: 'Apellido',
    FORM_BY_STEPS_LASTNAME_HINT: 'Escribe tu apellido',
    FORM_BY_STEPS_NEXT_BUTTON: 'Continuar',
    FORM_BY_STEPS_COUNTRY_LABEL: 'País',
    FORM_BY_STEPS_COUNTRY_HINT: 'Selecciona un país',
    FORM_BY_STEPS_EMAIL_LABEL: 'Correo corporativo',
    FORM_BY_STEPS_EMAIL_HINT: 'Escribe tu correo corporativo ',
    FORM_BY_STEPS_EMAIL_ERROR: 'Ingresa una dirección de correo válida',
    FORM_BY_STEPS_COMPANY_LABEL: 'Empresa',
    FORM_BY_STEPS_COMPANY_HINT: 'Escribe el nombre tu empresa',
    FORM_BY_STEPS_ROLE_LABEL: 'Puesto o cargo',
    FORM_BY_STEPS_ROLE_HINT: 'Escribe tu puesto o cargo',
    FORM_BY_STEPS_PHONE_LABEL: 'Número de Teléfono',
    FORM_BY_STEPS_BANNER_ERROR: 'Hubo un error al enviar.',
    FORM_BY_STEPS_DEMO_REQUEST:
      'Deseo recibir una demo personalizada de Crehana for Business',
    FORM_BY_STEPS_PROMOTION:
      'Deseo recibir promociones y noticias de Crehana for Business',

    LOADER_FINAL_COUNT_TITLE: 'Listo',

    FORM_STEPS_CONTEXT_1: 'Hola soy Carolina, para empezar ¿Cuál es tu nombre?',
    FORM_STEPS_CONTEXT_2: '¡Genial! ¿De dónde eres?',
    FORM_STEPS_CONTEXT_3: '¡Vamos muy bien! ¿Cuál es tu correo corporativo?',
    FORM_STEPS_CONTEXT_4:
      'Hablemos de tu organización. ¿Cuál es el nombre de tu empresa?',
    FORM_STEPS_CONTEXT_5: '¡Excelente! Dime el tamaño de tu empresa.',
    FORM_STEPS_CONTEXT_6: 'Unos últimos detalles. ¿Cuál es tu puesto o cargo?',
    FORM_STEPS_CONTEXT_7: '¿En que departamento trabajas?',
    FORM_STEPS_CONTEXT_8: 'Para finalizar. ¿Cuál es tu número de teléfono?',

    VALIDATIONS_REQUIRED: 'Campo requerido',
    VALIDATIONS_MAX_LENGTH: '`Máximo {{max}} caracteres',

    NAME_LABEL: 'Nombre',
    REQUIRED_FIELD: 'Campo requerido',
    REQUIRED_NAME: 'Nombre requerido',
    INVALID_NAME: 'El nombre es inválido',
    LAST_NAME_LABEL: 'Apellido',
    REQUIRED_LAST_NAME: 'Apellido requerido',
    INVALID_LAST_NAME: 'El apellido es inválido',

    //  step completed
    STEP_COMPLETED_TITLE: 'Solicitaste una prueba demo',
    STEP_COMPLETED_SUB_TITLE:
      'Un asesor se comunicará contigo para ayudarte y brindarte más información.',
    STEP_COMPLETED_CTA_LABEL: 'Entendido',

    // User departments
    USER_DEPARTMENT_HINT: 'Selecciona una opción',
    USER_DEPARTMENT_LABEL: 'Área de trabajo',
    //
    USER_DEPARTMENT_HR: 'Recursos Humanos',
    USER_DEPARTMENT_INNOVATION_IT: 'Innovación',
    USER_DEPARTMENT_MARKETING: 'Marketing',
    USER_DEPARTMENT_MANAGEMENT: 'Administración',
    USER_DEPARTMENT_SALES: 'Ventas',
    USER_DEPARTMENT_TI: 'TI',
    USER_DEPARTMENT_OPERATIONS: 'Operaciones',
    USER_DEPARTMENT_FINANCES: 'Finanzas',
    USER_DEPARTMENT_OTHER: 'Otros',

    // User roles
    USER_ROLE_HINT: 'Selecciona una opción',
    USER_ROLE_LABEL: 'Cargo laboral',
    //
    USER_ROLE_CEO: 'CEO/Gerente General',
    USER_ROLE_C_LEVEL: 'C Level/Gerente',
    USER_ROLE_VP: 'Vice Presidente',
    USER_ROLE_MANAGER: 'Manager',
    USER_ROLE_FOUNDER: 'Fundador',
    USER_ROLE_DIRECTOR: 'Director',
    USER_ROLE_COORDINATOR: 'Coordinador',
    USER_ROLE_EXECUTIVE: 'Ejecutivo',
    USER_ROLE_ANALIST: 'Analista',
    USER_ROLE_INTERN: 'Practicante/Pasante',
    USER_ROLE_FREELANCE: 'Independiente',
    USER_ROLE_STUDENT: 'Estudiante',
    USER_ROLE_OTHER: 'Otro',
  },
};

export default localeEs;
